import {Swiper, SwiperSlide} from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y, EffectCube } from 'swiper';
import 'swiper/css';
import { useCallback, useEffect, useRef, useState } from 'react';
import {  useTranslation } from 'next-i18next';
import { CarouselNavigator, Dot, PostBlocWrapper, PostCardStyled } from './styles';
import { ArrowLeft, ArrowRight } from './arrowIcons';
import { useRouter } from 'next/router';
import { StaticI18nLink } from '../../Link';

const getWindowWidth = () => {
  return 
}

export const BlogPostsCarousel = ({ posts }) => {
  const [activeSlide, setActiveSlide] = useState(0); // manter o state para atualizar os bullets
  const sliderRef = useRef(null);
  const [windowWidth, setWindowWidth] = useState(getWindowWidth());
  const increaseSlidesScreenBreakpoint = 576;
  const lastSlideActiveDesktop = 2;

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getActiveSwiperSlide = () => sliderRef?.current?.swiper?.activeIndex;

  const handlePrev = useCallback(() => {
    if (!sliderRef.current || isFirstSlideActive()) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current || isLastSlideActive()) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const postsToSlide = () => {
    let chunkSize = 3;

    if (windowWidth <= 576) {
      chunkSize = 1;
    }

    const postsChunks = [];

    for (let i = 0; i < posts.length; i += chunkSize) {
      postsChunks.push(posts.slice(i, i + chunkSize));
    }

    return postsChunks;
  };

  const isFirstSlideActive = () => getActiveSwiperSlide() === 0;
  
  const isLastSlideActive = () => {
    let isLastSlideActive = getActiveSwiperSlide() === lastSlideActiveDesktop;
    if (shoudIncreaseSlides()) {
      isLastSlideActive = getActiveSwiperSlide() === (posts?.length - 1)
    }

    return isLastSlideActive;
  }

  const shoudIncreaseSlides = () => windowWidth <= increaseSlidesScreenBreakpoint;

  const carouselNavigator = () => {
    return (
      <CarouselNavigator>
        <div className='dotsNavigationWrapper'>
          <Dot active={getActiveSwiperSlide() === 0}/>
          <Dot active={getActiveSwiperSlide() === 1}/>
          <Dot active={getActiveSwiperSlide() === 2}/>
          {
            shoudIncreaseSlides() && (
              <>
                <Dot active={getActiveSwiperSlide() === 3}/>
                <Dot active={getActiveSwiperSlide() === 4}/>
                <Dot active={getActiveSwiperSlide() === 5}/>
                <Dot active={getActiveSwiperSlide() === 6}/>
                <Dot active={getActiveSwiperSlide() === 7}/>
                <Dot active={getActiveSwiperSlide() === 8}/>
              </>
            )
          }
        </div>
        <div className={'buttonsNavigationWrapper'}>
          <div
            className={`prev_slide ${isFirstSlideActive() ? 'disabled' : '' }`}
            onClick={handlePrev}
          >
            <ArrowLeft className={'arrow'}/>
          </div>
          <div
            className={`next_slide ${isLastSlideActive() ? 'disabled' : ''}`}
            onClick={handleNext}
          >
            <ArrowRight className={'arrow'}/>
          </div>
        </div>
      </CarouselNavigator>
    )
  }

  return (
    <>
      <Swiper
        ref={sliderRef}
        style={{
          margin: windowWidth < 992 ? `0 6.15vw` : `0 5.55vw`,
          overflow: 'visible',
        }}
        loop={false}
        noSwipingSelector='.postLink'
        modules={[Pagination]}
        spaceBetween={0.0694 * windowWidth}
        slidesPerView={1}
        scrollbar={{ draggable: true }}
        onSlidePrevTransitionStart={({ activeIndex }) => setActiveSlide(activeIndex)}
        onSlideNextTransitionStart={({ activeIndex }) => setActiveSlide(activeIndex)}
        >
        {postsToSlide().map((chunk, index) => (
          <SwiperSlide key={index}>
              <PostBlocWrapper>
                {chunk.map((post) => (
                  <PostCard
                    key={post.metadata.imagem_inicio.url}
                    title={post.title}
                    image={`${post.metadata.imagem_inicio.imgix_url}?w=500&auto=format,compress&q=80`}
                    slug={post.slug}
                  />
                  ))}
              </PostBlocWrapper>
            </SwiperSlide>
          ))}
      </Swiper>
      {carouselNavigator()}
    </>
  )
}

const PostCard = ({ title, image, slug }) => {
  const { t } = useTranslation();
  const [windowWidth, setWindowWidth] = useState(getWindowWidth());
  const router = useRouter();
  
  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <PostCardStyled windowWidth={windowWidth} image={image} >
      <div className={'postOverlay'}>
        <div className={'postTextWrapper'}>
          <p className={'postTitle'}>{title}</p>
        </div>
        <div className={'postLinkWrapper'}>
          <StaticI18nLink href={`/blog/${slug}`}>
            <a className={'postLink'}>{t('blogSection.readMore')}</a>
          </StaticI18nLink>
          <img className={'arrowLeft'} src="/landings/assets/icons/forward.svg" alt={t('blogSection.arrowForward')} />
        </div>
      </div>
    </PostCardStyled>
  );
}
